module.exports = __webpack_public_path__ + "img/booth-combo.66fdd720.jpg";